// extracted by mini-css-extract-plugin
export default {"searchContainer":"AccountLogosList_searchContainer__6A0X8","cardContainer":"AccountLogosList_cardContainer__KnvpB"};